import React from 'react';

export interface MenuIconProps {
  size?: number | string;
  color?: string;
  className?: string;
}

const MenuIcon: React.FC<MenuIconProps> = ({ 
  size = 24, 
  color = 'currentColor',
  className = '' 
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={{ color }}
    >
      <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M2.5 10.604h15m-15-5h15m-15 10h15"/>
    </svg>
  );
};

export default MenuIcon;
